<input
    *ngIf="rowData"
    type="checkbox"
    [disabled]="disabled"
    [(ngModel)]="rowData[property]"
/>
